import airbridge from 'airbridge-web-sdk-loader';

airbridge.init({
  app: import.meta.env.VITE_AIRBRIDGE_APP_NAME,
  webToken: import.meta.env.VITE_AIRBRIDGE_WEB_TOKEN,
});
